import { render, staticRenderFns } from "./CategoryPagination.vue?vue&type=template&id=4065a663"
import script from "./CategoryPagination.vue?vue&type=script&lang=js"
export * from "./CategoryPagination.vue?vue&type=script&lang=js"
import style0 from "./CategoryPagination.vue?vue&type=style&index=0&id=4065a663&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports